module.exports = __webpack_public_path__ + "static/media/defaultimg.f540a12d.png";